var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcbLogoreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#ebf1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 24h4.4c1.001 0 2.2-1.195 2.2-2.133V8H7.2C6.199 8 5 9.195 5 11.2z",
    fill: "#047ab1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.497 18.816A9.283 9.283 0 0 1 5 18.475V17.3c.63.378 1.35.591 2.09.619.847 0 1.32-.576 1.32-1.365v-3.222h2.09v3.222c0 1.258-.682 2.261-3.003 2.261z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 24h4.4c1.001 0 2.2-1.195 2.2-2.133V8h-4.4c-1.001 0-2.2 1.195-2.2 3.2z",
    fill: "#d42d06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 14.08c.638-.597 1.738-.97 3.52-.885.968.042 1.98.32 1.98.32v1.184a4.574 4.574 0 0 0-1.903-.608c-1.353-.118-2.178.618-2.178 1.909s.825 2.027 2.178 1.92a4.64 4.64 0 0 0 1.903-.619v1.174s-1.012.288-1.98.33c-1.782.086-2.882-.288-3.52-.885z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 24h4.4c1.001 0 2.2-1.195 2.2-2.133V8h-4.4c-1.001 0-2.2 1.195-2.2 3.2z",
    fill: "#67b637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 17.28c0 .853-.682 1.387-1.595 1.387H20.4v-5.334h3.553l.253.011c.803.043 1.397.501 1.397 1.29 0 .62-.407 1.153-1.144 1.28v.033c.814.053 1.441.554 1.441 1.333zm-2.805-3.104a1.032 1.032 0 0 0-.143-.01h-1.32v1.343h1.463c.275-.064.506-.309.506-.672 0-.362-.231-.608-.506-.661zm.165 2.176a.975.975 0 0 0-.176-.01h-1.452v1.46h1.452l.176-.02c.275-.065.506-.342.506-.715 0-.374-.22-.64-.506-.715z",
    fill: "#fff"
  })))));
}
export default SvgJcbLogoreact;